/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_status" */
export enum ArgoWorkOrderStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  WorkOrderStatusPkey = 'work_order_status_pkey'
}

export enum ArgoWorkOrderStatusEnum {
  /** The work order has been completed */
  Completed = 'completed',
  /** The work order has been manually completed */
  ManuallyCompleted = 'manually_completed',
  /** The work order ready for production */
  Released = 'released',
  /** The work order is not ready for production */
  Staged = 'staged'
}

/** select columns of table "argo.work_order_status" */
export enum ArgoWorkOrderStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.work_order_status" */
export enum ArgoWorkOrderStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

